import React, { useEffect, useState } from "react";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBBtn,
} from "mdb-react-ui-kit";
// import GymLogo from '../components/images/Easy-MembrLogo.png'
// import GymLogo from '../../components/images/Easy-MembrLogo.png'
import GymLogo from "../../components/images/easybook.png";
import { classRandomTid, createClassTransaction, logEvent, uploadClassInvoice } from "../../services/classApiServices.js";
import PayNow from "../../components/class/payNow";
import BookingSuccess from "../../components/class/BookingSuccess";
import Loader from "../../components/Loader";
import { formatDate } from "../../utils/DateFormat"
import { browserName, browserVersion } from "react-device-detect";
import moment from "moment";
import { idToSlug } from "../../utils/slug";
import { useAnalytics } from "../../hooks/useAnalytics";
import { sendClassConfirmation } from "../../services/apiServices";

const ScheduleInvoice = ({ scheduleinfo, selectedMembers, memeberInfo, bussinessinfo, discountMembers, callbackUrl, downloadInvoice, Ip, uniqueNumber, selectedAddons, volumeDiscount, filteredAddons }) => {

    console.log("scheduleinfo", scheduleinfo, selectedMembers, volumeDiscount);

    const { trackButtonClick } = useAnalytics();
    const storedNumber = sessionStorage.getItem("classnumber");
    const number = storedNumber ? JSON.parse(storedNumber) : null;

    const classInfo = scheduleinfo.classInfo ? scheduleinfo.classInfo : {}
    const scheduleData = scheduleinfo.scheduleinfo ? scheduleinfo.scheduleinfo : {}
    const [billingname, setBillingname] = useState(memeberInfo && memeberInfo.length > 0 ? memeberInfo[0] : {})
    const [transaction, setTransaction] = useState({})
    const [success, setSuccess] = useState(false)
    const [loader, setLoader] = useState(false)


    const [confirmMailData, setConfirmMailData] = useState([])



    const membersinfo = memeberInfo && memeberInfo.length > 0
        ? memeberInfo.map((member) => {

            const discountEntry = discountMembers && discountMembers.find(discount => discount.memberid === member._id);
            const discount = discountEntry ? parseFloat(discountEntry.discount) || 0 : 0;

            const price = classInfo.price ? parseFloat(classInfo.price) || 0 : 0;

            const totalAmount = price - (price * (discount / 100));

            const memberAddonIds = selectedAddons && selectedAddons.length > 0 && selectedAddons
                ? selectedAddons.filter(addon => addon.memberId === member._id)
                : [];

            const memberAddons = memberAddonIds.map(addon => ({
                id: addon.id,
                name: addon.name,
                price: addon.price
            }));

            return {

                id: member._id,
                membername: `${member.fname} ${member.lname}`.trim(),
                number: member.number,
                discount: discountEntry ? discountEntry.discount : 0,
                totalamount: totalAmount.toFixed(2),
                addons: memberAddons

            };
        })
        : [];


    const classPrice = parseFloat(classInfo.price || 0);
    const participantCount = memeberInfo?.length || 0;
    const classTotal = classPrice * participantCount;


    const addonsTotal = selectedAddons && selectedAddons.length > 0
        ? selectedAddons.reduce((total, addon) => total + (parseFloat(addon?.price) || 0), 0)
        : 0;

    const membershipDiscountTotal = discountMembers?.reduce((total, discount) => {
        return total + ((classPrice * parseFloat(discount.discount || 0)) / 100);
    }, 0) || 0;


    const findAppliedVolumeDiscount = () => {
        const selectedCount = selectedMembers.length;
        const volumeDiscounts = scheduleinfo?.classInfo?.volumediscount || [];

        // Sort by discount percentage in descending order to get the best discount
        const sortedDiscounts = [...volumeDiscounts]
            .sort((a, b) => parseFloat(b.discount) - parseFloat(a.discount));

        // Find the discount with the highest discount where selectedCount meets the minParticipants
        for (const discount of sortedDiscounts) {
            if (selectedCount >= parseInt(discount.minParticipants || 0)) {
                return discount;
            }
        }

        return null;
    };


    // // Get the applied volume discount object
    // const appliedVolumeDiscount = findAppliedVolumeDiscount();

    // // Update the volume discount calculation to use the actual discount object
    // let volumeDiscountTotal = 0;     
    // let volumeDiscountPercentage = 0;

    // if (appliedVolumeDiscount && participantCount >= parseInt(appliedVolumeDiscount.minParticipants || 0)) {
    //     volumeDiscountPercentage = parseFloat(appliedVolumeDiscount.discount || 0);
    //     volumeDiscountTotal = (classTotal * volumeDiscountPercentage) / 100;
    // }



    // const totalAmount = classTotal + addonsTotal - membershipDiscountTotal - volumeDiscountTotal;


    // Find the applied volume discount object
    const appliedVolumeDiscount = findAppliedVolumeDiscount();

    // Update the volume discount calculation to use the actual discount object
    let volumeDiscountTotal = 0;
    let volumeDiscountPercentage = 0;

    if (appliedVolumeDiscount && participantCount >= parseInt(appliedVolumeDiscount.minParticipants || 0)) {
        volumeDiscountPercentage = parseFloat(appliedVolumeDiscount.discount || 0);
        volumeDiscountTotal = (classTotal * volumeDiscountPercentage) / 100;
    }

    // Calculate total amount step by step
    let totalAmount = classTotal + addonsTotal;

    // Apply volume discount first
    totalAmount -= volumeDiscountTotal;

    // Only apply membership discount if total is still positive after volume discount
    if (totalAmount > 0) {
        totalAmount -= membershipDiscountTotal;
    }

    // Ensure total doesn't go negative
    totalAmount = Math.max(totalAmount, 0);





    const groupedAddons = selectedAddons && selectedAddons.reduce((acc, addon) => {
        const existing = acc.find(item => item.id === addon.id);
        if (existing) {
            existing.quantity += 1;
            existing.totalPrice += addon.price;
            existing.members.push(addon.memberName);
        } else {
            acc.push({
                id: addon.id,
                name: addon.name,
                price: addon.price,
                quantity: 1,
                totalPrice: addon.price,
                members: [addon.memberName]
            });
        }
        return acc;
    }, []);



    // useEffect(() => {
    // ProcessTransaction()
    // }, [])

    // const generateTid = () => {
    //     return Math.random().toString(36).substring(2, 10).toUpperCase();
    // };

    // console.log(discountMembers);



    // const ProcessTransaction = () => {
    //     console.log(scheduleinfo);

    // const bussinessaddress = {
    //     name: bussinessinfo.businessName ? bussinessinfo.businessName : "",
    //     address: bussinessinfo.address ? bussinessinfo.address : "",
    //     logourl: bussinessinfo.logourl ? bussinessinfo.logourl : '',
    //     email: bussinessinfo.businessEmail ? bussinessinfo.businessEmail : "",
    //     number: bussinessinfo.contactNumber ? bussinessinfo.contactNumber : "",
    //     city: bussinessinfo.city ? bussinessinfo.city : "",
    //     state: bussinessinfo.state ? bussinessinfo.state : "",
    //     country: bussinessinfo.country ? bussinessinfo.country : "",
    // }


    //     console.log(membersinfo, '9000000000000000000777777777777777');

    //     // const discountAmount = classInfo.price
    //     const transaction = {
    //         tid: generateTid(),

    //         classid: scheduleinfo.classid,
    //         trainerid: scheduleinfo.trainerid,
    //         scheduleid: scheduleinfo._id,
    //         quantity: memeberInfo && memeberInfo.length,
    //         bid: scheduleinfo.bid,
    //         startdate: scheduleinfo.startdate,
    //         expirydate: scheduleinfo.enddate,
    //         membersid: membersinfo,
    //         // taxamounts: ,
    //         cancellationpolicyid: scheduleinfo.cancellationpolicyid,
    //         // transid: ,
    //         gst: bussinessinfo.dgsttax.length > 0 && bussinessinfo.dgsttax[0] === 1 ? bussinessinfo.gstnumber : "",
    //         // totalamount: ,
    //         // discount: ,
    //         itemprice: classInfo.price,
    //         bussinessaddress: bussinessaddress
    //     }

    //     setTransaction(transaction)

    // }
    // console.log(membersinfo, '333333333333333333333');

    // ProcessTransaction()

    
    const [trnsid, setTrnsid] = useState(null)
    useEffect(() => {
        if (trnsid == null) {
            classRandomTid().then(async (res) => {
                if (res && res !== "false") {
                    const data = await res.json();
                    setTrnsid(data.id);
                }
            });
        }
    }, [])
    // const totalAmount = membersinfo && membersinfo.length > 0 ? membersinfo.reduce((sum, item) => sum + parseFloat(item.totalamount), 0) : 0;
    console.log(membersinfo, memeberInfo);

    // const totalDiscountAmount = parseFloat((classInfo.price * (memeberInfo && memeberInfo.length)).toFixed(2)) - totalAmount

    const callbackfunction = async (data) => {
        if (isBooking) return;
        setIsBooking(true);
        try {
            if (data == "offline") {
                await payNowHandle(data)
            }
            setLoader(true)
            setLoader(false)
            setSuccess(true)
        } catch (e) {
            setIsBooking(false);
        }
    }
    const processing = async (data) => {
        await payNowHandle(data)
    }
        
    const [trans, setTrans] = useState(null)
    const [isBooking, setIsBooking] = useState(false)

    const adjustStartWithTimeslot = (start, timeslot) => {

        console.log("start, timeslot", start, timeslot)

        if (!start || !timeslot) return new Date(start);

        const base = moment(start);

        const slotMoment = moment(timeslot, "hh:mm A");

        // Compare
        if (base.hour() === slotMoment.hour() && base.minute() === slotMoment.minute()) {
            // Times already match → just return backend date
            return base.toDate();
        }

        const fixed = moment(base.format("YYYY-MM-DD") + " " + timeslot, "YYYY-MM-DD hh:mm A");
        return fixed.toDate();
    };


    const mergedStart = adjustStartWithTimeslot(scheduleData?.startdate, scheduleinfo?.startTime);

    function encryptId(id) {
        return btoa(id);
    }
    const [waiverLink, setWaiverLink] = useState("")
    const payNowHandle = async (data) => {

        console.log("dataaaaaa", data)


        const slug = encryptId(trnsid);
        console.log(slug, 'slug');
        let uniqueId = uniqueNumber;
        const encryptedId = encryptId(uniqueId);
        const link = `${window.location.origin}/classtranswaiver?id=${encryptedId}&tid=${slug}`
        console.log(link, 'link');
        setWaiverLink(link)
        const ip = Ip || "-";
        const browserinfo = `${browserName}-${browserVersion}.0.0`;
        const memberNamesString = memeberInfo?.map(member => `${member?.fname || ""} ${member?.lname || ""}`.trim())
            .join(", ") || "";
        const className = scheduleinfo?.classInfo?.name || "-";
        const trainerEmail = scheduleinfo?.trainerInfo?.email || "-";
        const trainergymid = scheduleinfo?.trainerInfo?.gid || "-"
        const flag = `Class (${className}) booked by (${memberNamesString})`;



        const memberUpdates = memeberInfo?.map(member => {
            const memberid = member._id;
            const memberslug = idToSlug(memberid);
            let memberuniqueId = uniqueNumber; // Note: This might need to be unique per member
            const memberencryptedId = encryptId(memberuniqueId);
            const memberlink = `${window.location.origin}/waiver?id=${memberencryptedId}&mId=${memberslug}`;

            console.log(memberlink, 'link');

            return {
                link: memberlink,
                id: memberid,
            };
        }) || [];
        const bussinessaddress = {
            name: bussinessinfo.businessName ? bussinessinfo.businessName : "",
            address: bussinessinfo.address ? bussinessinfo.address : "",
            logourl: bussinessinfo.logourl ? bussinessinfo.logourl : '',
            email: bussinessinfo.businessEmail ? bussinessinfo.businessEmail : "",
            number: bussinessinfo.contactNumber ? bussinessinfo.contactNumber : "",
            city: bussinessinfo.city ? bussinessinfo.city : "",
            state: bussinessinfo.state ? bussinessinfo.state : "",
            country: bussinessinfo.country ? bussinessinfo.country : "",
        }


        const transaction = {
            tid: trnsid,
            classid: scheduleData?.classid || classInfo?._id,
            trainerid: scheduleData?.trainerid,
            scheduleid: scheduleData?._id || scheduleData?.recurrenceid,
            quantity: membersinfo?.length || 0,
            bid: scheduleData?.bid,
            startdate: mergedStart || "",
            expirydate: scheduleData?.enddate || "",
            membersid: membersinfo || [],
            cancelfee: scheduleinfo.cancellationPolicy.length > 0 ? scheduleinfo.cancellationPolicy : [],
            cancellationpolicyid: scheduleData?.cancellationpolicyid || "",
            gst: bussinessinfo?.dgsttax?.length > 0 && bussinessinfo?.dgsttax[0] === 1 ? (bussinessinfo?.gstnumber ? bussinessinfo?.gstnumber : null) : null,
            itemprice: classInfo?.price || "0",
            bussinessaddress: bussinessaddress,
            mode: data !== "offline" ? "online" : data,
            razorpay_order: data !== null && data !== "offline" ? data : {},
            totalamount: totalAmount,
            status: data !== "offline" ? "pending" : "success",
            memberLinks: memberUpdates,
            volumediscount: appliedVolumeDiscount ? {
                _id: appliedVolumeDiscount._id, // Store the original _id
                discount: appliedVolumeDiscount.discount, // String "13"
                minParticipants: appliedVolumeDiscount.minParticipants, // String "6"
                checked: appliedVolumeDiscount.checked,
                amount: volumeDiscountTotal // Actual discount amount in rupees
            } : null,

        };

        console.log(transaction, '7777777777777777777777777777777777777');
        const res = await createClassTransaction(transaction.bid, transaction)
        console.log(res, '666666666666666');
        if (!res || res === "false") {
            return;
        }
        console.log(res);

        const transinfo = await res.json();

        if (res.status === 204 && transinfo?.message) {
            alert(transinfo.message);
            callbackUrl();
            return;
        }
        await trackButtonClick("ScheduleInvoice", "Create_ClassBooking_Transaction", "member", {});


        console.log(transinfo);
        await logEvent(
            {
                Eventtype: number,
                username1: trainerEmail,
                fullName: memberNamesString,
                ip,
                flag,
                browserinfo,
                gymid: trainergymid,
                isclass: true
            },
            trainergymid
        );


        if (transinfo.data && transinfo?.data?.tid) {
            const linkrespos = await uploadClassInvoice(transinfo?.data?.tid, { invoiceId: transinfo?.data?.tid, Gid: transinfo?.data?.bid })
            console.log(linkrespos, 'linkrespos');
            if (!linkrespos || linkrespos === "false") {
                return;
            }
            // console.log(linkrespos);

            const traninfo = await linkrespos.json();

            const invoiceUrl = traninfo.data?.pdfFileLink || traninfo?.pdfFileLink || "";

            setTrans(transinfo?.data)


            const confirmationData = {
                transactionId: transinfo?.data?._id,
                className: classInfo?.name,
                scheduleDate: mergedStart,
                totalAmount: totalAmount,
                memberNames: memberNamesString,
                businessId: scheduleData?.bid,
                trainerName: scheduleinfo?.trainerInfo?.name || "",
                trainerEmail: scheduleinfo?.trainerInfo?.email || "",
                memberEmails: memeberInfo.map(m => m.email),
                invoiceLink: invoiceUrl,
            };


            if (data == "offline" || data === "offline") {
                try {
                    console.log("cominggginoffline")

                    await sendClassConfirmation(confirmationData);
                    console.log('Confirmation email sent successfully');
                } catch (error) {
                    console.error('Error sending confirmation email:', error);
                }
            }

            console.log("confirmationDataaaaaaaaaaaas")
            setConfirmMailData(confirmationData)

            // await sendClassConfirmation(confirmationData);

        }
    }

    const homeCallback = () => {
        callbackUrl()
    }
    const date = formatDate(new Date());

    console.log(bussinessinfo, 'bussinessinfo');
    console.log(bussinessinfo?.classpaymentmode === "offline" || totalAmount === 0);
    const userdetails = {
        name: billingname.fname ? billingname.fname + " " + billingname.lname : "",
        email: billingname?.email || '',
        contact: billingname.number ? billingname.number : ""
    }

    const discountDisplay = volumeDiscount?.discount || appliedVolumeDiscount?.discount || 0;
    return (
        <div fluid className="p-0 p-md-5 h-100">
            {!success ? <>
                {loader ? <Loader /> : <div className="mx-3"> <MDBRow className="mb-4">
                    <MDBCol md="6">
                        <img src={bussinessinfo && bussinessinfo.logourl ? bussinessinfo.logourl : GymLogo} alt="" className="logoImg" />
                        <p className="text-dark mt-4">
                            <div className="header-address">
                                <h6>{bussinessinfo?.businessName || ""}</h6>
                                {bussinessinfo?.contactNumber && <p>{bussinessinfo.contactNumber}</p>}
                                {bussinessinfo?.businessEmail && <p>{bussinessinfo.businessEmail}</p>}
                                {(bussinessinfo?.address || bussinessinfo?.city || bussinessinfo?.state) && (
                                    <p>
                                        {bussinessinfo.address && `${bussinessinfo.address}`}
                                        {bussinessinfo.address && (bussinessinfo.city || bussinessinfo.state) && ', '}
                                        {bussinessinfo.city && `${bussinessinfo.city}`}
                                        {bussinessinfo.city && bussinessinfo.state && ', '}
                                        {bussinessinfo.state && `${bussinessinfo.state}`}
                                    </p>
                                )}
                            </div>

                        </p>
                    </MDBCol>
                    <MDBCol md="6" className="text-end">
                        {/* <h5 className="fw-bold text-dark">Invoice</h5> */}
                        <span class="primary-color">Billed to</span>
                        <h3 class="primary-color"><strong>{billingname.fname ? billingname.fname + " " + billingname.lname : ""}{(billingname.number) ? ', ' : ''}</strong></h3>
                        <p className="text-dark">
                            {/* <strong className="text-success ">{bussinessinfo.businessName}</strong> */}


                            {billingname.number ? billingname.number : ""}
                            <p class="primary-color">{billingname.address ? billingname.address : ""}{(billingname.address && (billingname.city || billingname.country)) ? ', ' : ''}<br />
                                {billingname.city ? billingname.city : ""}{(billingname.country && billingname.country) ? ', ' : ''}{billingname.country ? billingname.country : ''}</p>
                        </p>
                        <p>
                            {/* <strong>Invoice No:</strong> {transaction.tid ? transaction.tid : ""} */}
                            {/* <br /> */}
                            <strong>Issue Date:</strong> {date}
                            {/* <h6 classname="primary-color"><strong>Transaction ID: {transaction.tid ? transaction.tid : ""}</strong></h6> */}
                        </p>

                    </MDBCol>
                </MDBRow>

                    <MDBTable responsive borderless>
                        <MDBTableHead className="bg-light">
                            <tr>
                                <th>Description</th>
                                <th>Quantity</th>
                                <th>Unit Price (₹)</th>
                                <th className="text-end">Amount (₹)</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            <tr>
                                <td>{classInfo.name}</td>
                                <td>{memeberInfo && memeberInfo.length}</td>
                                <td> + &#8377;{parseFloat(classInfo.price).toFixed(2)
                                    .toLocaleString('en-IN')}</td>
                                <td className="text-end">

                                    + &#8377;{parseFloat(
                                        (classInfo.price
                                            * (memeberInfo && memeberInfo.length)
                                        ).toFixed(2)
                                    ).toLocaleString('en-IN')}
                                </td>
                            </tr>

                            {(groupedAddons ?? []).map((addon, index) => (
                                <tr key={`addon-${addon?.id ?? index}`}>
                                    <td>
                                        <div className="text-dark">{addon?.name || '-'}</div>
                                        {/* <p className="text-muted">
                                            For: {(addon?.members ?? []).join(', ') || '-'}
                                        </p> */}
                                    </td>

                                    <td>{addon?.quantity ?? 0}</td>

                                    <td>+ ₹{Number(addon?.price ?? 0).toFixed(2)}</td>

                                    <td className="text-end">
                                        + ₹{Number(addon?.totalPrice ?? 0).toFixed(2)}
                                    </td>
                                </tr>
                            ))}

                        </MDBTableBody>
                    </MDBTable>

                    <MDBRow className="mt-4">
                        <MDBCol md="6" />
                        <MDBCol md="6">
                            {/* <div className="d-flex align-items-center p-2 justify-content-end">
                                <div className="fw-bold w-50">Membership Discount</div>
                                <div className="fw-bold text-end"> - &#8377;{totalDiscountAmount.toLocaleString('en-IN')}</div>
                            </div> */}


                            <div className="d-flex align-items-center p-2 justify-content-end">
                                <div className="fw-bold w-50">Volume Discount ({discountDisplay}%)</div>
                                <div className="fw-bold text-end">- ₹{volumeDiscountTotal.toFixed(2)}</div>
                            </div>


                            <div className="d-flex align-items-center p-2 justify-content-end">
                                <div className="fw-bold w-50">Membership Discount</div>
                                <div className="fw-bold text-end">- ₹{membershipDiscountTotal.toFixed(2)}</div>
                            </div>
                            {/* <div className="d-flex align-items-center p-2 justify-content-end">
                        <div className="fw-bold w-50">Tax</div>
                        <div className="fw-bold text-end">+ ₹100</div>
                    </div> */}
                            <div className="d-flex align-items-center p-2 justify-content-end">
                                <div className="fw-bold w-50">Total</div>
                                <div className="fw-bold text-end">&#8377;{totalAmount.toLocaleString('en-IN')}</div>
                            </div>
                        </MDBCol>
                    </MDBRow>

                    {/* <MDBRow className="mt-4">
                <MDBCol md="6" />
                <MDBCol md="6" className="text-end">
                    <h4 className="fw-bold">TOTAL (Rupees)</h4>
                    <h4>&#8377;{totalAmount.toLocaleString('en-IN')}</h4>
                </MDBCol>
            </MDBRow> */}

                    <MDBRow className="mt-4">
                        <MDBCol className="text-end">
                            <MDBBtn color="light" className="me-2" onClick={callbackUrl}>
                                Cancel
                            </MDBBtn>
                            {/* <MDBBtn color="success" onClick={payNowHandle}>Pay Now</MDBBtn> */}
                            {(bussinessinfo?.classpaymentmode && bussinessinfo?.classpaymentmode === "online" && totalAmount !== 0) ? (
                                <PayNow
                                    amount={totalAmount}
                                    callback={callbackfunction}
                                    gymid={bussinessinfo?._id ? bussinessinfo._id : -1}
                                    user={userdetails}
                                    title={"Pay"}
                                    from="Class Booking"
                                    processing={processing}

                                />

                            ) : (

                                <button type="button" className="btn btn-primary" onClick={() => callbackfunction("offline")} disabled={isBooking}>
                                    {isBooking ? "Booking..." : "Book"}
                                </button>
                            )}
                        </MDBCol>
                    </MDBRow>
                    <div className="text-end mt-5">
                        <p className="text-muted m-0">Issued by,</p>
                        <p className="fw-bold">{bussinessinfo && bussinessinfo?.name ? bussinessinfo.name : "Easymembr"}</p>
                    </div></div>}

            </> : <>
                <BookingSuccess homeCallback={homeCallback} trans={trans} downloadInvoice={downloadInvoice} waiverLink={waiverLink} confirmMailData={confirmMailData} />
            </>}
        </div>
    );
};

export default ScheduleInvoice


